<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'UserList'}">
            Paramétrage compte
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator" />
        <div class="page-header-breadcrumb-item">
          <span class="has-text-weight-normal has-text-grey-dark">{{ currentUser.account.name }}</span>
        </div>
      </template>
    </page-nav-bar>
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <page-content
      v-else-if="!loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
            <figure
              class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right"
              @mouseover="userAvatarHover = true"
              @mouseleave="userAvatarHover = false">
              <router-link
                data-tooltip="Editer la fiche"
                class="dot is-large has-background-light--darken3 has-text-white is-border is-border--white tooltip is-tooltip-right"
                :to="{name: 'ProfilInfo', params: {id: currentUser.pk}}">
                <span class="icon"><i class="fas fa-pen" /></span>
              </router-link>
              <div class="is-border is-border--circle is-clipped">
                <upload-file
                  :source-documents="[currentUser.account.picture]"
                  :is-avatar="true"
                  :show-list="false"
                  class="is-border--circle is-clipped"
                  :label-class="''"
                  @upload="uploadUserAvatar($event)" />
              </div>
            </figure>
          </div>
          <aside class="menu menu--admin menu--admin--notFat is-border-top">
            <ul class="menu-list has-background-white">
              <li
                v-if="isAdmin"
                :class="{'is-active' :$route.name === 'ProfilCompanyInfo' && !isActiveNotification}">
                <router-link :to="{name: 'ProfilCompanyInfo', params: {id: currentUser.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="far fa-address-card" /></span>Informations compte</span>
                </router-link>
              </li>
              <li
                v-if="isAdmin && isPromoteur"
                :class="{'is-active' :$route.name === 'PromoteurPresentation' && !isActiveNotification}">
                <router-link :to="{name: 'PromoteurPresentation', params: {id: currentUser.account.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="far fa-file-user" /></span>Fiche de présentation</span>
                </router-link>
              </li>
              <li
                v-if="isAdmin && isPromoteur"
                :class="{'is-active' :$route.name === 'ContractList' && !isActiveNotification}">
                <router-link :to="{name: 'ContractList', params: {id: currentUser.account.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="far fa-file-user" /></span>Documents personnalisé</span>
                </router-link>
              </li>
              <li
                v-if="isAdmin"
                :class="{'is-active' :$route.name === 'CustomFields' && !isActiveNotification}">
                <router-link :to="{name: 'CustomFields', params: {id: currentUser.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="fal fa-clipboard-list"></i></span>Champs formulaire</span>
                </router-link>
              </li>
              <li
                v-if="isAdmin && currentUser.first_admin"
                :class="{'is-active' :$route.name === 'ProfilParamsSecurity' && !isActiveNotification}">
                <router-link :to="{name: 'ProfilParamsSecurity', params: {id: currentUser.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="fal fa-shield-check"></i></span>Paramétrage de sécurité</span>
                </router-link>
              </li>
            </ul>
          </aside>
        </div>
      </template>
      <div class="has-background-white is-border">
        <router-view :key="$route.name" />
      </div>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues, Quickview } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Account',
  mixins: [DefaultValues, Quickview],
  data () {
    return {
      isActiveNotification: false,
      userAvatarHover: false,
      isInitialized: false
    }
  },
  computed: {
    ...mapState(['quickview']),
    ...mapGetters(['isAdmin', 'isPromoteur'])
  },
  watch: {
    '$route.name' (value, oldValue) {
      if (value !== oldValue) {
        this.initAccountTab()
      }
    },
    quickview ({ mode, params, results, close }) {
      if (results && mode === 'MANAGE_NOTIFICATION') {
        this.isActiveNotification = false
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.$emit('updateUser', results.results)
      }
      if (close) {
        this.isActiveNotification = false
      }
      if (results && mode === 'USER_SELECTION' && this.user.profil === 'seller') {
        if (results.entities.length) {
          this.$emit('updateManager', results.entities[0])
        } else {
          this.$toasted.global.danger('Veuillez séléctionner un manager')
        }
      }
    }
  },
  mounted () {
    // this.initAccountTab()
  },
  methods: {
    async initAccountTab () {
      if (['CustomFieldForm', 'ContractList', 'CustomFields', 'ProfilParamsSecurity'].includes(this.$route.name)) {
        this.isInitialized = true
      }
      if (!this.isInitialized) {
        this.$router.push({ name: 'ProfilCompanyInfo' })
        this.isInitialized = true
      }
    }
  }
}
</script>
